import API from '@/api/home.js';
import {mapState} from 'vuex'

const pageMixin = {
    componentName: 'PagePermissionName',
    data: function () {
        return {
            isPageAllowed:true,
            mixinLoading:false,
            pageAction:[],
        }
    },
    computed:{
        ...mapState({
            addRoutes: state => state.permission.addRoutes,
        }),
    },
    created: function () {
        this.getPageAllowAction();
    },
    methods:{
        getPageAllowAction(){
            let routeMeta = this.$route.meta;

            let appleRoute = this._findFieldByName(this.addRoutes,'apple');
            console.log('appleRoute',appleRoute);
            if(!appleRoute) {
                this.isPageAllowed = false;
                this.isPageAllowed = false;
                this.pageFields = [];
                this.pageFunc = [];
                this.pageDimension = [];
                this.pageAction = [];
                return false;
            }

            let navId = (appleRoute.meta||{}).id;

            this.mixinLoading = true;
            API.getPageAllowAction({
                action_id:navId,
            }).then(res => {
                let resData = res.data||{};
                console.log(1111,resData);

                let actionData = resData.page_action||[];
                this.pageAction = actionData;



                if(actionData.length<=0){
                    this.isPageAllowed = false;
                    this.pageAction = [];
                }else if(routeMeta.isTabItem){

                    let pageName = this.$route.name;
                    let pageItem = actionData.find(item=>item.name==pageName);
                    this.isPageAllowed = !!pageItem;
                    if(pageItem){
                        this.pageFields = this._getFlatArray(pageItem.fields,[]);
                        this.pageFunc = pageItem.func;
                        this.pageDimension = pageItem.dimension;
                    }
                }else{
                    this.isPageAllowed = true;

                    let dailyTaskPage = actionData.find(item=>item.name=='daily_task_page');
                    if(dailyTaskPage){
                        let periodConfig = dailyTaskPage.statistical_period||[];
                        this.$store.commit('dailyTask/UPDATE_PERIOD_CONFIG', periodConfig);
                    }
                }

                /* initPageStates方法需要在宿主页面里定义后才能正确调用 */
                if(this.initPageStates){
                    this.initPageStates();
                }
                this.mixinLoading = false;
            }, (err) => {
                console.log('getPageAllowAction error', err);
                this.isPageAllowed = false;
                this.mixinLoading = false;
                this.pageAction = [];
            });
        },
        _getFlatArray(list,result){
            list.forEach(item=>{
                if(!item.children){
                    result.push(item);
                }else if(item.children&&item.children.length>0){
                    return this._getFlatArray(item.children,result);
                }
            });
            return result;
        },
        _findFieldByName(data, name) {
            for (let item in data) {
                if (data[item].name == name) {
                    return data[item];
                } else {
                    let child = data[item].children;
                    if (child && child.length > 0) {
                        let result = this._findFieldByName(child, name);
                        if (result) {
                            return result;
                        }
                    }
                }
            }
        },
    }
};

export {
    pageMixin,
}
